// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gallery {
  background: var(--light-color);
}

.gallery-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 28px;
  margin-bottom: 56px;
}

.gallery-item {
  position: relative;
  border-radius: 20px;
  overflow: hidden;
  cursor: pointer;
  aspect-ratio: 4/3;
  background: var(--white);
  box-shadow: var(--shadow-md);
  border: 1px solid var(--border-color);
  transition: var(--transition);
}

.gallery-item:hover {
  box-shadow: var(--shadow-xl);
  border-color: transparent;
}

.gallery-item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: var(--transition);
}

.gallery-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(to top, rgba(0, 0, 0, 0.8) 0%, transparent 60%);
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  padding: 24px;
  opacity: 0;
  transition: var(--transition);
}

.gallery-item:hover .gallery-overlay {
  opacity: 1;
}

.gallery-item:hover img {
  transform: scale(1.1);
}

.gallery-category {
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 1px;
  color: var(--secondary-color);
  margin-bottom: 8px;
}

.gallery-title {
  font-size: 18px;
  font-weight: 600;
  color: var(--white);
  margin: 0 0 12px 0;
}

.gallery-icon {
  position: absolute;
  top: 24px;
  right: 24px;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.9);
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--primary-color);
  opacity: 0;
  transform: scale(0.8);
  transition: var(--transition);
}

.gallery-item:hover .gallery-icon {
  opacity: 1;
  transform: scale(1);
}

.gallery-cta {
  text-align: center;
  padding: 40px;
  background: var(--white);
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
}

.gallery-cta p {
  font-size: 18px;
  color: var(--text-color);
  margin-bottom: 20px;
  font-weight: 500;
}

.lightbox {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.95);
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px;
  animation: fadeIn 0.3s ease-out;
}

.lightbox-close {
  position: absolute;
  top: 30px;
  right: 30px;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.1);
  border: none;
  color: var(--white);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: var(--transition);
  z-index: 2001;
}

.lightbox-close:hover {
  background: rgba(255, 255, 255, 0.2);
  transform: rotate(90deg);
}

.lightbox-content {
  max-width: 1200px;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  animation: scaleIn 0.3s ease-out;
}

.lightbox-content img {
  max-width: 100%;
  max-height: 80vh;
  object-fit: contain;
  border-radius: 12px;
  margin-bottom: 20px;
}

.lightbox-info {
  text-align: center;
  color: var(--white);
}

.lightbox-category {
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 1px;
  color: var(--secondary-color);
  margin-bottom: 8px;
  display: block;
}

.lightbox-title {
  font-size: 24px;
  font-weight: 600;
  color: var(--white);
  margin: 0;
}

@keyframes scaleIn {
  from {
    opacity: 0;
    transform: scale(0.9);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

@media (max-width: 968px) {
  .gallery-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 16px;
  }
}

@media (max-width: 640px) {
  .gallery-grid {
    grid-template-columns: 1fr;
  }

  .lightbox {
    padding: 20px;
  }

  .lightbox-close {
    top: 20px;
    right: 20px;
    width: 40px;
    height: 40px;
  }

  .lightbox-content img {
    max-height: 70vh;
  }
}

`, "",{"version":3,"sources":["webpack://./src/components/Gallery.css"],"names":[],"mappings":"AAAA;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,wBAAwB;EACxB,4BAA4B;EAC5B,qCAAqC;EACrC,6BAA6B;AAC/B;;AAEA;EACE,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,2EAA2E;EAC3E,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,aAAa;EACb,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;EAC3B,UAAU;EACV,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,wBAAwB;EACxB,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,+BAA+B;EAC/B,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oCAAoC;EACpC,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,aAAa;AACf;;AAEA;EACE,oCAAoC;EACpC,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,6BAA6B;EAC7B,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE;IACE,UAAU;IACV,qBAAqB;EACvB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,qCAAqC;IACrC,SAAS;EACX;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,SAAS;IACT,WAAW;IACX,WAAW;IACX,YAAY;EACd;;EAEA;IACE,gBAAgB;EAClB;AACF","sourcesContent":[".gallery {\n  background: var(--light-color);\n}\n\n.gallery-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 28px;\n  margin-bottom: 56px;\n}\n\n.gallery-item {\n  position: relative;\n  border-radius: 20px;\n  overflow: hidden;\n  cursor: pointer;\n  aspect-ratio: 4/3;\n  background: var(--white);\n  box-shadow: var(--shadow-md);\n  border: 1px solid var(--border-color);\n  transition: var(--transition);\n}\n\n.gallery-item:hover {\n  box-shadow: var(--shadow-xl);\n  border-color: transparent;\n}\n\n.gallery-item img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  transition: var(--transition);\n}\n\n.gallery-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: linear-gradient(to top, rgba(0, 0, 0, 0.8) 0%, transparent 60%);\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  padding: 24px;\n  opacity: 0;\n  transition: var(--transition);\n}\n\n.gallery-item:hover .gallery-overlay {\n  opacity: 1;\n}\n\n.gallery-item:hover img {\n  transform: scale(1.1);\n}\n\n.gallery-category {\n  font-size: 12px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n  color: var(--secondary-color);\n  margin-bottom: 8px;\n}\n\n.gallery-title {\n  font-size: 18px;\n  font-weight: 600;\n  color: var(--white);\n  margin: 0 0 12px 0;\n}\n\n.gallery-icon {\n  position: absolute;\n  top: 24px;\n  right: 24px;\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.9);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--primary-color);\n  opacity: 0;\n  transform: scale(0.8);\n  transition: var(--transition);\n}\n\n.gallery-item:hover .gallery-icon {\n  opacity: 1;\n  transform: scale(1);\n}\n\n.gallery-cta {\n  text-align: center;\n  padding: 40px;\n  background: var(--white);\n  border-radius: 16px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);\n}\n\n.gallery-cta p {\n  font-size: 18px;\n  color: var(--text-color);\n  margin-bottom: 20px;\n  font-weight: 500;\n}\n\n.lightbox {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.95);\n  z-index: 2000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 40px;\n  animation: fadeIn 0.3s ease-out;\n}\n\n.lightbox-close {\n  position: absolute;\n  top: 30px;\n  right: 30px;\n  width: 50px;\n  height: 50px;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.1);\n  border: none;\n  color: var(--white);\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: var(--transition);\n  z-index: 2001;\n}\n\n.lightbox-close:hover {\n  background: rgba(255, 255, 255, 0.2);\n  transform: rotate(90deg);\n}\n\n.lightbox-content {\n  max-width: 1200px;\n  max-height: 90vh;\n  display: flex;\n  flex-direction: column;\n  animation: scaleIn 0.3s ease-out;\n}\n\n.lightbox-content img {\n  max-width: 100%;\n  max-height: 80vh;\n  object-fit: contain;\n  border-radius: 12px;\n  margin-bottom: 20px;\n}\n\n.lightbox-info {\n  text-align: center;\n  color: var(--white);\n}\n\n.lightbox-category {\n  font-size: 12px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n  color: var(--secondary-color);\n  margin-bottom: 8px;\n  display: block;\n}\n\n.lightbox-title {\n  font-size: 24px;\n  font-weight: 600;\n  color: var(--white);\n  margin: 0;\n}\n\n@keyframes scaleIn {\n  from {\n    opacity: 0;\n    transform: scale(0.9);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n@media (max-width: 968px) {\n  .gallery-grid {\n    grid-template-columns: repeat(2, 1fr);\n    gap: 16px;\n  }\n}\n\n@media (max-width: 640px) {\n  .gallery-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .lightbox {\n    padding: 20px;\n  }\n\n  .lightbox-close {\n    top: 20px;\n    right: 20px;\n    width: 40px;\n    height: 40px;\n  }\n\n  .lightbox-content img {\n    max-height: 70vh;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
